<ng-container *transloco="let t; read: 'downloads'">
  <div class="p-5">
    <div>
      <drdp-title [title]="t('ratingsAndScores.title', { year: '2025' })"></drdp-title>
      <div>
        <p>{{ t('ratingsAndScores.description') }}</p>
      </div>
    </div>
    <drdp-download-search [is2025Page]="true" (searchClicked)="downloadDemographics($event)"></drdp-download-search>
  </div>

</ng-container>
